module.exports = __webpack_public_path__ + "static/media/17.3895b9e6.jpg";